import { bonCardApi } from "./bonCardApi";
import authSlice from "./../features/auth/authSlice";
import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { rtkQueryOnForbiddenLogout } from "./apiMiddleware";
import breadcrumbState from "../states/breadcrumbState";

export const persistConfig = {
  key: "root",
  storage,
  version: 1,
  blacklist: [bonCardApi.reducerPath, breadcrumbState.name],
};

const rootReducer = combineReducers({
  auth: authSlice,
  breadcrumb: breadcrumbState,
  [bonCardApi.reducerPath]: bonCardApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(bonCardApi.middleware)
      .concat(rtkQueryOnForbiddenLogout),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
